module.exports = __webpack_public_path__ + "img/phase1-2013-09.64ea2e78.jpg";